// (c) TwistedMinds, Gerry Uytdenhouwen - 3 november 2026

// Number of detail lines shown in a table cell before it is cut off.
export const DETAILS_MAX_LINES = 4;

// Vuetify theme colour per status key.
export const STATUS_COLOR = {
    open: 'primary',
    paid: 'success',
    canceled: 'warning',
    expired: 'error',
    failed: 'error',
};

/**
 * Pickup date and time as one string: '31-10-2026 10:30'.
 * Without a time only the date is returned, without a date an empty string.
 */
export const formatPickupMoment = (date, time) => {
    if (!date) {
        return '';
    }
    return time ? `${date} ${time}` : date;
};

/**
 * Order details split into lines; the empty line after a trailing newline is dropped.
 */
export const detailsLines = (details) => {
    if (!details) {
        return [];
    }
    const lines = details.split(/\r?\n/);
    if (lines[lines.length - 1] === '') {
        lines.pop();
    }
    return lines;
};

/**
 * Status as used by the table: 'created' counts as 'open', anything unknown as 'failed'.
 */
export const statusKey = (status) => {
    if (status === 'created' || status === 'open') {
        return 'open';
    }
    return Object.prototype.hasOwnProperty.call(STATUS_COLOR, status) ? status : 'failed';
};

/**
 * Flag columns (printed, notified) arrive as 0/1 or as a timestamp string.
 */
export const isFlagOn = (value) => Boolean(value);

// Same rule as the existing table in dashboard/orders/Index.vue.
export const isNewOrder = (item) => item.is_printed === 0 || !item.notified_at;

/**
 * '2026-10-31 12:38:10' -> '31-10-2026 12:38'; empty string when missing or unreadable.
 */
export const formatNotifiedAt = (value) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(value || '');
    return match ? `${match[3]}-${match[2]}-${match[1]} ${match[4]}:${match[5]}` : '';
};
